import { NavLink } from 'react-router-dom';
import { Box, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Typography, Divider, Button } from '@mui/material';
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import BugReportRoundedIcon from '@mui/icons-material/BugReportRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../slices/portalAuthSlice';
import { tokens } from '../../theme/theme';
import BrandLogo from '../../components/branding/BrandLogo';

const DRAWER_WIDTH = 232;

const NAV_ITEMS = [
  { label: 'Overview', path: '/portal', icon: SpaceDashboardRoundedIcon },
  { label: 'Reports & Compliance', path: '/portal/reports', icon: DescriptionRoundedIcon },
  { label: 'Vulnerabilities', path: '/portal/vulnerabilities', icon: BugReportRoundedIcon },
  { label: 'Notifications', path: '/portal/notifications', icon: NotificationsRoundedIcon },
  { label: 'Support', path: '/portal/support', icon: SupportAgentRoundedIcon }
];

export default function PortalSidebar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/portal/login');
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          backgroundColor: tokens.bg.surface,
          borderRight: `1px solid ${tokens.border}`
        }
      }}
    >
      <Box sx={{ px: 2.2, py: 2.1 }}>
        <BrandLogo compact dark />
        <Typography variant="overline" sx={{ color: tokens.brand.main, display: 'block', mt: 1.1, fontSize: '0.58rem' }}>CyberGuard Client Portal</Typography>
      </Box>
      <Divider sx={{ borderColor: tokens.border }} />
      <List sx={{ px: 1.2, py: 1.5 }}>
        {NAV_ITEMS.map(({ label, path, icon: Icon }) => (
          <ListItemButton
            key={path}
            component={NavLink}
            to={path}
            end={path === '/portal'}
            sx={{
              borderRadius: 1.5,
              mb: 0.5,
              color: tokens.text.secondary,
              '&.active': {
                backgroundColor: tokens.brand.glow,
                color: tokens.text.primary,
                '& .MuiListItemIcon-root': { color: tokens.brand.main }
              },
              '&:hover': { backgroundColor: tokens.bg.elevated }
            }}
          >
            <ListItemIcon sx={{ minWidth: 36, color: 'inherit' }}>
              <Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ fontSize: '0.88rem', fontWeight: 500 }}>
              {label}
            </ListItemText>
          </ListItemButton>
        ))}
      </List>
      <Box sx={{ mt: 'auto', p: 1.5, borderTop: `1px solid ${tokens.border}` }}>
        <Button
          fullWidth size="small" startIcon={<LogoutRoundedIcon fontSize="small" />}
          onClick={handleLogout}
          sx={{ justifyContent: 'flex-start', color: tokens.text.secondary, textTransform: 'none' }}
        >
          Sign out
        </Button>
      </Box>
    </Drawer>
  );
}

export { DRAWER_WIDTH };
